var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("jet-form-section", {
    on: { submitted: _vm.updatePassword },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v(" Update Password ")]
        },
        proxy: true,
      },
      {
        key: "description",
        fn: function () {
          return [
            _vm._v(
              "\n        Ensure your account is using a long, random password to stay secure.\n    "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "col-span-6 sm:col-span-4" },
              [
                _c("jet-label", {
                  attrs: { for: "current_password", value: "Current Password" },
                }),
                _vm._v(" "),
                _c("jet-input", {
                  ref: "current_password",
                  staticClass: "mt-1 block w-full",
                  attrs: {
                    id: "current_password",
                    type: "password",
                    autocomplete: "current-password",
                  },
                  model: {
                    value: _vm.form.current_password,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "current_password", $$v)
                    },
                    expression: "form.current_password",
                  },
                }),
                _vm._v(" "),
                _c("jet-input-error", {
                  staticClass: "mt-2",
                  attrs: { message: _vm.form.errors.current_password },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-span-6 sm:col-span-4" },
              [
                _c("jet-label", {
                  attrs: { for: "password", value: "New Password" },
                }),
                _vm._v(" "),
                _c("jet-input", {
                  staticClass: "mt-1 block w-full",
                  attrs: {
                    id: "password",
                    type: "password",
                    autocomplete: "new-password",
                  },
                  model: {
                    value: _vm.form.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "password", $$v)
                    },
                    expression: "form.password",
                  },
                }),
                _vm._v(" "),
                _c("jet-input-error", {
                  staticClass: "mt-2",
                  attrs: { message: _vm.form.errors.password },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-span-6 sm:col-span-4" },
              [
                _c("jet-label", {
                  attrs: {
                    for: "password_confirmation",
                    value: "Confirm Password",
                  },
                }),
                _vm._v(" "),
                _c("jet-input", {
                  staticClass: "mt-1 block w-full",
                  attrs: {
                    id: "password_confirmation",
                    type: "password",
                    autocomplete: "new-password",
                  },
                  model: {
                    value: _vm.form.password_confirmation,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "password_confirmation", $$v)
                    },
                    expression: "form.password_confirmation",
                  },
                }),
                _vm._v(" "),
                _c("jet-input-error", {
                  staticClass: "mt-2",
                  attrs: { message: _vm.form.errors.password_confirmation },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              "jet-action-message",
              {
                staticClass: "mr-3",
                attrs: { on: _vm.form.recentlySuccessful },
              },
              [_vm._v("\n            Saved.\n        ")]
            ),
            _vm._v(" "),
            _c(
              "jet-button",
              {
                class: { "opacity-25": _vm.form.processing },
                attrs: { disabled: _vm.form.processing },
              },
              [_vm._v("\n            Save\n        ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }